import React from 'react';
import PropTypes from 'prop-types';
import {Select} from './CheckoutPage.style';

const RenderDropdownList = ({input, data, onTimeChange}) => {
  const onChange = event => {
    input.onChange(event.target.value);
    onTimeChange(event.target.value);
  };

  return (
    <Select
      {...input}
      onChange={onChange}
    >
      {
        data.map(item => (
          <option
            value={item.value}
            key={`${item.label}${item.value}`}
          >
            {item.label}
          </option>
        ))
      }
    </Select>
  );
};

RenderDropdownList.propTypes = {
  input: PropTypes.object.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired
};

export default RenderDropdownList;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/RenderDropdownList.js